import { cva, cx } from 'class-variance-authority';

import { Icon } from '~/components/primitives';
import React from 'react';

const Variant = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
} as const;

export const alertVariant = cva('', {
    variants: {
        variant: {
            [Variant.INFO]: 'bg-blue-50 text-blue-500',
            [Variant.WARNING]: 'bg-yellow-100 text-yellow-900',
            [Variant.ERROR]: 'bg-red-100 text-red-800',
        },
    },
    defaultVariants: {
        variant: Variant.INFO,
    },
});

const Alert: React.FC<{
    title?: React.ReactNode;
    children?: React.ReactNode;
    variant?: (typeof Variant)[keyof typeof Variant];
    className?: string;
}> = props => (
    <div
        className={alertVariant({
            variant: props.variant,
            className: cx('flex items-center gap-3 rounded-2xl p-4 text-sm', props.className),
        })}
    >
        <header className="flex items-center gap-3">
            <Icon name="info-circle" className="shrink-0" />
            {props.title}
        </header>
        {props.children}
    </div>
);

export default Alert;
